import { render, staticRenderFns } from "./superSearchPeriod.vue?vue&type=template&id=74b352d7&"
import script from "./superSearchPeriod.vue?vue&type=script&lang=js&"
export * from "./superSearchPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/superSearch/superSearchPeriod.vue"
export default component.exports